import { useCallback } from "react";

import useTeacherUpdate from "@/teacher/hooks/useTeacherUpdate";

const useRemoveTeacherSchool = (user) => {
  const [updateTeacher] = useTeacherUpdate();
  return useCallback(async () => {
    const response = await updateTeacher({
      id: user.teacher.id,
      school: null,
      school_id: null,
    });
    if (response.error) throw response.error;
    return response;
  }, [user, updateTeacher]);
};

export default useRemoveTeacherSchool;
